export default {
  path: '/reports/overview',
  name: 'ReportsOverview',
  component: () => import(/* webpackChunkName: "base" */ '../views/ReportsView.vue')
}
